import { useWeb3React } from '@web3-react/core';
import { useTokenAllowance } from "../../../hooks/useTokenAllowance";
import { useUpdaterChainId } from "../../../hooks/web3";
import { BEST_BUY } from '@tokenlon/sdk';
export var useBestBuyAllowance = token => {
  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account;

  var expectChainId = useUpdaterChainId();
  return useTokenAllowance(token, account, BEST_BUY[expectChainId]);
};